module.exports = __webpack_public_path__ + "static/media/outlook_icon.5c9028b1.png";